import React from "react";

export default function ProductCard({ product, onViewClick }) {

  const displayImage = product.images ? product.images[0] : product.image;

  return (
    <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12 mb-4">
      <div className="card h-100 shadow-sm product-card">
        {/* Product Image */}
        <img
          src={displayImage}
          alt={product.name}
          className="card-img-top"
          onClick={() => onViewClick(product.id)}
          style={{ height: "180px", objectFit: "cover" }}
        />

        <div className="card-body">
          <h6 className="card-title">{product.name}</h6>
          <p className="text-muted mb-1">{product.category}</p>
          {/* <p className="fw-semibold mb-2">₹{product.price}</p> */}

          <button 
            className="btn btn-outline-primary w-100"
            onClick={() => onViewClick(product.id)}
          >
            View Details
          </button>
        </div>
      </div>
    </div>
  );
}